var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
import { filterData, getUsers } from '@web/lib/demo/utils';
import { processDriveAnalyticCalculation } from '@workalizer/shared/services/processDriveAnalytic';
import { getInterval } from '@workalizer/shared/utils';
export var driveAnalytic = function (input) {
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var documentEvents = filterData(documentEventsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ]).map(function (item) { return (__assign(__assign({}, item), { date: new Date(item.date), createdAt: new Date(item.createdAt), updatedAt: new Date(item.updatedAt) })); });
    var dateFrom = new Date(input.dateFrom);
    var dateTo = new Date(input.dateTo);
    var interval = getInterval(dateFrom, dateTo);
    return processDriveAnalyticCalculation(documentEvents, dateFrom, dateTo, interval);
};
